export default __webpack_public_path__ + "static/media/kcs-logo.092f6509.svg";